import { render, staticRenderFns } from "./EmailRegisteredWithSocialAccountModal.vue?vue&type=template&id=4effbf9a&scoped=true&"
import script from "./EmailRegisteredWithSocialAccountModal.vue?vue&type=script&lang=js&"
export * from "./EmailRegisteredWithSocialAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailRegisteredWithSocialAccountModal.vue?vue&type=style&index=0&id=4effbf9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4effbf9a",
  null
  
)

export default component.exports